
	import { defineComponent } from 'vue';

	import { IWorkflowInstanceStatus } from '@/Models/Workflow/IWorkflowInstanceStatus';
	import { IDataTableHeader } from '@/Models/IDataTableHeader';

	import { WorkflowService } from '@/Services/workflow-service';
	import { DateHelper } from '@/Services/Helper/date-helper';
	import LoadingSpinner from '@/ChildrenComponents/LoadingSpinner.vue';

	export default defineComponent({
		name: 'workflow-history',
		components: { LoadingSpinner },
		props: {
			workflowInstanceId: {
				type: Number,
				required: true
			},
		},
		created() {
			this.loadHistory();
		},
		data() {
			return {
				isLoading: true,
				statusList: [] as IWorkflowInstanceStatus[],
				headers: [
					{ title: "Status", key: "workflowStatusDescription", sortable: true, align: "start" },
					{ title: "User", key: "createdBy", sortable: true, align: "start" },
					{ title: "Date", key: "createDate", sortable: true, align: "start" },
					{ title: "Note", key: "note", sortable: true, align: "start" },
				] as IDataTableHeader[],
			}
		},
		methods: {
			loadHistory() {
				this.isLoading = true;
				WorkflowService.getStatusHistory(this.workflowInstanceId)
					.then(response => this.statusList = response)
					.finally(() => this.isLoading = false);
			},
			formatDate(date: Date): string {
				return DateHelper.formatDateLocal(date, "MM/dd/yyyy h:mm tt z");
			},
		},
		watch: {
			workflowInstanceId() {
				this.loadHistory();
			},
		},
	}); 
